/**
 * 브라우저 핑거프린트 및 디바이스 정보 유틸리티
 */

/**
 * 브라우저 핑거프린트 생성
 * Canvas, WebGL, 화면 정보 등을 조합하여 고유 ID 생성
 */
export const getBrowserFingerprint = () => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const txt = 'Browser Fingerprint';
  
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillText(txt, 2, 2);
  
  const canvasData = canvas.toDataURL();
  
  // 브라우저 정보 수집
  const fingerprint = {
    canvas: canvasData,
    userAgent: navigator.userAgent,
    language: navigator.language,
    screenResolution: `${screen.width}x${screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    platform: navigator.platform,
    hardwareConcurrency: navigator.hardwareConcurrency,
    deviceMemory: navigator.deviceMemory,
  };
  
  // 해시 생성 (간단한 해시 함수)
  const hashString = JSON.stringify(fingerprint);
  let hash = 0;
  for (let i = 0; i < hashString.length; i++) {
    const char = hashString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // localStorage에서 기존 ID 확인 (재방문 시 동일한 ID 유지)
  const storedId = localStorage.getItem('device_id');
  if (storedId) {
    return storedId;
  }
  
  const deviceId = `desktop_${Math.abs(hash).toString(16)}_${Date.now().toString(36)}`;
  localStorage.setItem('device_id', deviceId);
  
  return deviceId;
};

/**
 * 디바이스 정보 가져오기
 */
export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  
  // 브라우저 정보 파싱
  let browserName = 'Unknown';
  let browserVersion = '';
  
  if (userAgent.indexOf('Chrome') > -1) {
    browserName = 'Chrome';
    browserVersion = userAgent.match(/Chrome\/(\d+)/)?.[1] || '';
  } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    browserName = 'Safari';
    browserVersion = userAgent.match(/Version\/(\d+)/)?.[1] || '';
  } else if (userAgent.indexOf('Firefox') > -1) {
    browserName = 'Firefox';
    browserVersion = userAgent.match(/Firefox\/(\d+)/)?.[1] || '';
  } else if (userAgent.indexOf('Edge') > -1) {
    browserName = 'Edge';
    browserVersion = userAgent.match(/Edge\/(\d+)/)?.[1] || '';
  }
  
  // OS 정보 파싱
  let osName = 'Unknown';
  if (platform.indexOf('Win') > -1) osName = 'Windows';
  else if (platform.indexOf('Mac') > -1) osName = 'macOS';
  else if (platform.indexOf('Linux') > -1) osName = 'Linux';
  
  return {
    deviceType: 'DESKTOP',
    deviceName: `${browserName} ${browserVersion} on ${osName}`,
    userAgent,
    platform,
    browserName,
    browserVersion,
    osName
  };
};

/**
 * 디바이스 ID 저장
 */
export const saveDeviceId = (deviceId) => {
  localStorage.setItem('device_id', deviceId);
};

/**
 * 저장된 디바이스 ID 가져오기
 */
export const getSavedDeviceId = () => {
  return localStorage.getItem('device_id');
};

/**
 * 디바이스 ID 삭제
 */
export const clearDeviceId = () => {
  localStorage.removeItem('device_id');
};